import React from "react";
import { IconButton } from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { Domain } from "../../../models/Domain";
import { domainStorage } from "../../../utils/domainStorage";
import { useStoredDomain } from "../../../hooks/useStoredDomain";

type Props = {
  domain: Domain;
};

const SelectDomainAction: React.FC<Props> = ({ domain }) => {
  const selectedDomain = useStoredDomain();

  const handleChooseDomain = () => {
    domainStorage.set(domain);
  };

  const handleUnchooseDomain = () => {
    domainStorage.clear();
  };

  if (selectedDomain) {
    return (
      <IconButton
        size="small"
        color="error"
        title="unchoose domain"
        onClick={handleUnchooseDomain}
      >
        <GpsFixedIcon />
      </IconButton>
    );
  }

  return (
    <IconButton
      size="small"
      color="success"
      title="Choose domain"
      onClick={handleChooseDomain}
    >
      <GpsFixedIcon />
    </IconButton>
  );
};

export default SelectDomainAction;
